/*
 * MDB shim for DropdownToggle
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/pageHeader.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Patient/PatientViewComponents/liaisonModal.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUIButton from "@mui/material/Button";
import { useContext } from "react";
import { DropdownContext } from "./Dropdown";

export default function DropdownToggle({ children, onClick, caret, ...rest }) {
    const context = useContext(DropdownContext);

    function handleClick(event) {
        const el = event.currentTarget;
        if (context?.anchorEl === el) {
            context.setAnchorEl(null);
        } else {
            context?.setAnchorEl(el);
        }
        context?.toggle?.(event);
        onClick?.(event);
    }

    return (
        <MUIButton {...rest} onClick={handleClick}>
            {children}
        </MUIButton>
    );
}